/**
 * 모패밀리 초대 페이지(/mofamily-invitation) 링크 단일 생성기.
 *
 * 이 헬퍼로만 링크를 만든다 (직접 문자열 조립 금지). 과거에 알림/링크를 손수 조립하다
 * code 누락(→"초대 코드가 없습니다"), code=undefined(snake/camel 불일치), review 누락
 * (→"이미 처리되었습니다") 버그가 반복됐다. 타입으로 code 를 강제하고, review 를 명시
 * 옵션으로 두며, 빈 code 는 조용히 넘기지 말고 throw 한다(조용한 /code=undefined 방지).
 */
export interface InvitationLinkParams {
  /** 초대 코드 (필수). 빈 값이면 throw — 깨진 링크를 만들지 않는다. */
  code: string;
  /** 역제안 등 '검토' 화면을 띄워야 할 때 true. (없으면 countered 가 '이미 처리됨'으로 막힘) */
  review?: boolean;
}

export function buildInvitationLink({ code, review }: InvitationLinkParams): string {
  if (!code) {
    throw new Error('buildInvitationLink: code 가 비어 있습니다 (초대 링크를 만들 수 없음)');
  }
  const params = new URLSearchParams({ code });
  if (review) params.set('review', 'true');
  return `/mofamily-invitation?${params.toString()}`;
}
